var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseNoBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#4C4C4C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95967 11.0949C1.66546 11.3237 1.24003 11.3029 0.96967 11.0325C0.676777 10.7396 0.676777 10.2648 0.96967 9.97188L4.94045 6.00111L0.96967 2.03033C0.676777 1.73744 0.676777 1.26256 0.96967 0.96967C1.24003 0.699307 1.66546 0.67851 1.95967 0.907279L2.03033 0.96967L6.00111 4.94045L9.97188 0.96967L10.0425 0.907278C10.3368 0.67851 10.7622 0.699307 11.0325 0.96967C11.3254 1.26256 11.3254 1.73744 11.0325 2.03033L7.06177 6.00111L11.0325 9.97188C11.3254 10.2648 11.3254 10.7396 11.0325 11.0325C10.7622 11.3029 10.3368 11.3237 10.0425 11.0949L9.97188 11.0325L6.00111 7.06177L2.03033 11.0325L1.95967 11.0949Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseNoBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloseNoBg.a27747f852726c4e3ad0475b16811b93.svg";